import { Cartesian3, Ray } from "cesium";
import { AssetType } from "../../types";
import { ERubbingDestination } from "../trench/types";
// this is in local coordinate system
export class ReferenceTopology {
    assetType = AssetType.REFERENCE_TOPOLOGY;
    terrainType = AssetType.REFERENCE_TOPOLOGY;
    targetType = ERubbingDestination.REFERENCE_TOPOLOGY;
    tileSet;
    _image;
    constructor(image) {
        this._image = image;
    }
    get geometry() {
        return this._image.getMeshGeometry();
    }
    get id() {
        return this._image.id;
    }
    get heightMap() {
        return this._image.heightMap;
    }
    getDrawing2DImage() {
        return this._image;
    }
    updateTransparency(value) {
        this._image.updateTransparency(value);
    }
    updateColor(color) {
        throw new Error("Method not implemented.");
    }
    updateVisibility(status) {
        this._image.updateVisibility(status);
    }
    zoomTo() {
        this._image.zoomTo();
    }
    /**
     *
     * @param ray in local coordinate system
     * @returns
     */
    rayCast(ray) {
        return this._image.rayCast(ray);
    }
    getProjectPointHeight(refPoint) {
        const ray = new Ray(new Cartesian3(refPoint.x, refPoint.y, refPoint.z + 10000), new Cartesian3(0, 0, -1));
        const pointOnTileset = this.rayCast(ray);
        return pointOnTileset !== undefined ? pointOnTileset.z : undefined;
    }
    dispose() {
        this._image.dispose();
    }
    getGeodeticNormal() {
        return new Cartesian3(0, 0, 1);
    }
    tracePoints(points) {
        return this._image.heightMap.tracePoints(points);
    }
}
//# sourceMappingURL=reference-topology.js.map